"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoToJSON = exports.VideoFromJSONTyped = exports.VideoFromJSON = exports.instanceOfVideo = void 0;
var runtime_1 = require("../runtime");
var AspectRatio_1 = require("./AspectRatio");
var Asset_1 = require("./Asset");
var VideoFileType_1 = require("./VideoFileType");
/**
 * Check if a given object implements the Video interface.
 */
function instanceOfVideo(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfVideo = instanceOfVideo;
function VideoFromJSON(json) {
    return VideoFromJSONTyped(json, false);
}
exports.VideoFromJSON = VideoFromJSON;
function VideoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, Asset_1.AssetFromJSONTyped)(json, ignoreDiscriminator)), { 'durationMs': !(0, runtime_1.exists)(json, 'duration_ms') ? undefined : json['duration_ms'], 'aspectRatio': !(0, runtime_1.exists)(json, 'aspect_ratio') ? undefined : (0, AspectRatio_1.AspectRatioFromJSON)(json['aspect_ratio']), 'width': !(0, runtime_1.exists)(json, 'width') ? undefined : json['width'], 'height': !(0, runtime_1.exists)(json, 'height') ? undefined : json['height'], 'fileType': !(0, runtime_1.exists)(json, 'file_type') ? undefined : (0, VideoFileType_1.VideoFileTypeFromJSON)(json['file_type']), 'hasAudio': !(0, runtime_1.exists)(json, 'has_audio') ? undefined : json['has_audio'], 'thumbnailUrl': !(0, runtime_1.exists)(json, 'thumbnail_url') ? undefined : json['thumbnail_url'] });
}
exports.VideoFromJSONTyped = VideoFromJSONTyped;
function VideoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, Asset_1.AssetToJSON)(value)), { 'duration_ms': value.durationMs, 'aspect_ratio': (0, AspectRatio_1.AspectRatioToJSON)(value.aspectRatio), 'width': value.width, 'height': value.height, 'file_type': (0, VideoFileType_1.VideoFileTypeToJSON)(value.fileType), 'has_audio': value.hasAudio, 'thumbnail_url': value.thumbnailUrl });
}
exports.VideoToJSON = VideoToJSON;
